import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faUserEdit, faUserPlus, faCartPlus, faPrint, faPlus, faFileExcel, faFileSignature, faDownload, faPlay, faEraser, faFilePdf, faFileCsv, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/administration/users/user.service';
import { ShopService } from 'src/app/administration/shops/shop.service';
import { PrinterService } from 'src/app/administration/printers/printer.service';
import { SalesStatementService } from '../../reports/sales-statement/sales-statement.service';
import { AuthService } from 'src/app/auth/auth.service';
import { PermissionEnum } from 'src/app/administration/users/user-permission.enum';
import { PrintPreviewService } from 'src/app/_common/services/print-preview.service';
import { PrintersStatusService } from 'src/app/reports/printers-status/printers-status.service';


@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss']
})
export class ActionButtonsComponent implements OnInit {
 
  faUserAdd = faUserPlus;
  faUserEdit = faUserEdit;
  faCartPlus = faCartPlus;
  faPrint = faPrint;
  faPlus = faPlus;
  faPdf = faFilePdf;
  faCsv = faFileCsv;
  faXlsx = faFileExcel;

  faResetFiltersSalesStatement = faEraser;
  faRunSalesStatement = faPlay;
  faPrintSalesStatement = faPrint;
  faDownloadSalesStatement = faDownload;
  faDownloadSalesBasedOnItemsStatement = faFileDownload;
  faPrintDocuments = faPrint;

  permissionEnum = PermissionEnum;

  constructor(private router: Router,
    private userService: UserService,
    private shopService: ShopService,
    private printerService: PrinterService,
    public salesStatementService: SalesStatementService,
    public authService: AuthService,
    public printPreviewService: PrintPreviewService,
    public printersStatusService: PrintersStatusService
  ) {}

  ngOnInit() {
  }

  isActiveRoute(routeName: string): boolean {
    return this.router.url === routeName;
  }

  onAddUser(): void {
    this.userService.callAddOrEditUserOpenDialog();
  }

  onAddShop(): void {
    this.shopService.callAddOrEditShopOpenDialog();
  }

  onAddPrinter(): void {
    this.printerService.callAddOrEditPrinterOpenDialog();
  } 

  onPrintSalesStatement(): void {
    this.salesStatementService.print();
  }

  onDownloadSalesStatement(type: string): void {
    this.salesStatementService.download(type);
  }

  onPrintDocumentView(): void {
    this.printPreviewService.printSelectedDocuments();
  }
  
  onDownloadPrintersStatus(type: string): void {
    this.printersStatusService.download(type);
  }

  onDownloadSalesStatementBasedOnItemsCsv(): void {
    this.salesStatementService.downloadSalesStatementBasedOnItems();
  }
}